import { jsx as _jsx } from "react/jsx-runtime";
import { Building2, CalendarDays, Captions, ClipboardList, ContactRound, FileText, Grid3x3, Home, Inbox, Link2, ListOrdered, MessageSquare, MoreHorizontal, Route, Star, Table2, Users, } from 'lucide-react';
const NAV_ICONS = {
    home: Home,
    queues: ListOrdered,
    engagements: Route,
    contract: FileText,
    projects: Table2,
    events: CalendarDays,
    priority: Star,
    funnel: Grid3x3,
    feedback: MessageSquare,
    tasks: ClipboardList,
    agents: Users,
    agencies: Building2,
    fixations: Link2,
    brandManagers: ContactRound,
    transcriptions: Captions,
    inquiries: Inbox,
    more: MoreHorizontal,
};
export function NavIconView({ name, className, }) {
    const Icon = NAV_ICONS[name];
    return _jsx(Icon, { className: className ?? 'h-5 w-5', "aria-hidden": true });
}
